var _module_exports ="<span gov-compile=\"visibleText\"></span>";;
var path = '/app/shared/procedure/prcInlineRef.default.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;